const KEY = 'last-workout-id';

/**
 * The workout the user last took part in on this device. The backend lists finished workouts only, so this is how
 * the catalogue finds one left half-way to offer it again. Storage may be blocked, which only hides that offer.
 */
export function rememberWorkout(workoutId: string): void {
    try {
        localStorage.setItem(KEY, workoutId);
    } catch {
        // Nothing to remember with storage blocked; resuming is a convenience
    }
}

export function rememberedWorkout(): string | undefined {
    try {
        return localStorage.getItem(KEY) ?? undefined;
    } catch {
        return undefined;
    }
}
